import { ContentTemplateInputRow, ContentTemplateRow } from "namirasoft-content-template";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { ContentTemplateLayout } from "../ContentTemplateLayout";
import { ContentTemplateEntities } from "../ContentTemplateEntities";
import { ContentTemplateProps } from "../ContentTemplateProps";
import { getContentTemplateParameterTab } from "../components/ContentTemplateParameterList";

interface IContentViewPageProps extends NSARouterMakerResult, ContentTemplateProps { }

function ContentViewPage(props: IContentViewPageProps)
{
	return (
		<ContentTemplateLayout<ContentTemplateRow, ContentTemplateInputRow>
			{...props}
			action={{
				title: "",
				description: "View and edit your existing content templates.",
				menus: {}
			}}
			pages={{
				entity: ContentTemplateEntities.content_template(props),
				view: {
					ui: {
						tab_page_view: { tabs: { extra: { after_general: [getContentTemplateParameterTab()] } } }
					}
				}
			}}
		>
			<></>
		</ContentTemplateLayout>
	)
}

export default ContentViewPage;